import React from 'react'
import { useCart } from 'lib/core/hooks'
import { ListItem } from '../ListItem'
import { Container } from './components/Styled'

export const ListWrapper = () => {
  const { cart } = useCart()
  const items = cart?.data?.items

  if (!items) {
    return null
  }

  return (
    <Container>
      <ul>
        {items.map(cartItem => {
          return (
            <ListItem
              key={cartItem.id}
              cartItem={cartItem}
            />
          )
        })}
      </ul>
    </Container>
  )
}
